var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('FeedstocksList',{attrs:{"ingredients":_vm.ingredients}}),_c('Results',{staticClass:"mt-5",attrs:{"feedstocks":_vm.ingredients}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }